import React from "react";
import PropTypes from "prop-types";
import { List, Typography, Box } from "@mui/material";
import DynamicNavItemForWeed from "./DynamicNavItemForWeed";

const DynamicNavGroupForWeed = ({item, level}) => {


    const navItems = item.children.map((dynamicItem) => (
        <DynamicNavItemForWeed key={dynamicItem.id} item={dynamicItem} level={1} />
      ));

  return (
    <List
    subheader={
      item.title && (
        <Box sx={{ pl: 3, mb: 1.5 }}>
          <Typography variant="subtitle2" color="textSecondary">
            {item.title}
          </Typography>
        </Box>
      )
    }
    sx={{ mb: 1.5, py: 0, zIndex: 0 }}
  >
    {navItems}
  </List>
  )
}

export default DynamicNavGroupForWeed